<template>
  <div class="container pad-btm15">
    <div class="seacrh home-searh">
      <i class="iconfont icon-sousuo"></i>
      <div class="search_txt">搜索你想购买的商品</div>
    </div>
    <mt-swipe :auto="4000" :show-indicators="imgUrlsList.length > 1 ? true : false">
      <template v-if="imgUrlsList.length > 0">
        <mt-swipe-item v-for="(item, index) in imgUrlsList" :key="index">
          <div @click="swiperPage(item.WechatPath, item.ID, item.PathOption)">
            <img :src="item.ImgUrl" />
          </div>
        </mt-swipe-item>
      </template>
      <template v-else>
        <mt-swipe-item>
          <div @click="entoRebatenote"><img :src="bannerImg" /></div>
        </mt-swipe-item>
      </template>
    </mt-swipe>
    <div class="suohuo_txt">
      <div class="flex">
        <i class="icon iconfont">&#xe674;</i>
        <div>淘宝购物</div>
      </div>
      <div class="flex">
        <i class="icon iconfont">&#xe674;</i>
        <div>售后无忧</div>
      </div>
      <div class="flex">
        <i class="icon iconfont">&#xe674;</i>
        <div>买贵就赔</div>
      </div>
      <div class="flex">
        <i class="icon iconfont">&#xe674;</i>
        <div>返利秒到账</div>
      </div>
    </div>
    <!-- 分类栏目 -->
    <category-tab></category-tab>
    <!-- 新人专区 -->
    <newcomer v-if="isNewcomer && !isZeroHideScore" :data-list="newcomerData"> </newcomer>
    <!-- 分类 -->
    <div id="order_type">
      <div class="sort_wrap" ref="wrapper">
        <ul class="sort_list">
          <li
            v-for="(item, index) in firstClassCategoryList"
            :key="index"
            :class="{
              active: currentIndex === index,
              lengthClass: item.Value.length < 3
            }"
            @click="switchListTab(index, item.Key)"
          >
            {{ item.Value }}
          </li>
          <span class="sort_line"></span>
        </ul>
        <div class="sort_icon">
          <i class="iconfont icon-down-trangle-copy" @click="entoSortPage"></i>
        </div>
      </div>
      <div class="subsort_wrap" ref="subWrapper" v-show="currentIndex !== 0 && isShowSecondCategory && !isFixed" :class="{ categoryShowAnim: isShowSecondCategory }">
        <ul class="subsort_list">
          <li v-for="(item, index) in secondClassCategoryList" :key="index">
            <div class="sort_img" @click="entoSearchResult(item.Name)">
              <img :src="item.LogoUrl" />
            </div>
            <p class="sort_txt">{{ item.Name }}</p>
          </li>
        </ul>
      </div>
      <!-- 筛选 -->
      <div class="sch-reult">
        <div class="s_result">
          <div
            class="t_999 filter_tab"
            :class="{
              filter_active: platformShopType === item.platformShopType
            }"
            v-for="(item, index) in platformTypeList"
            :key="index"
            @click="platformChange(item.platformShopType)"
          >
            <span>{{ item.collectively }}</span>
          </div>
          <div class="filter_end"></div>
        </div>
      </div>
    </div>
    <!-- 筛选子选项 -->
    <div id="sch-child" class="sch-child" :class="{ isFixed: isFixed }">
      <div class="sch-child-list">
        <div class="sch-child-item" :class="{ active: currentFilterItem === 'comprehensive' }" @click="filterChange('comprehensive')">综合</div>
        <div class="sch-child-item" :class="{ active: currentFilterItem === 'sale' }" @click="filterChange('sale')">销量</div>
        <div class="sch-child-item" :class="{ active: priceClickNum !== 0 }" @click="priceFilter">
          <div>
            价格
            <div class="icon-view">
              <div :class="{ 'triangle triangle-up': true, 'icon-up': priceClickNum && priceClickNum % 2 === 1 }"></div>
              <div :class="{ 'triangle triangle-down': true, 'icon-down': priceClickNum && priceClickNum % 2 === 0 }"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <souhuo-list
      :data-list="dataList"
      :is-fake-data="isFakeSkeleton"
      :is-newcomer="isNewcomer"
      :show-head="false"
      :scroll-disabled="scrollDisabled"
      @loadMore="loadMore"
      @entoDetailPage="entoDetailPage"
    >
    </souhuo-list>
    <!-- line -->
    <segement-Line v-if="!haveMore" line-text="没有更多商品啦"> </segement-Line>
    <segement-Line v-else :is-load="true"> </segement-Line>
    <!-- 说明展示按钮 -->
    <div class="poster_btn" @click="entoPosterDetail(false)">
      <img :src="posterBtnImg" />
    </div>
    <!-- 返回顶部 -->
    <quick-top @returnTop="returnTop" :isReturn="isReturn"></quick-top>
    <!-- 解决蒙版重叠 -->
    <div class="sh-dialog-mask" v-if="(isShowPoster || isReadLevel) && !getQrCodeIsShow"></div>
    <!-- 海报 -->
    <poster-dialog
      :image-url="posterLevelImage"
      :is-show-poster="isShowPoster || isReadLevel"
      :is-un-close="true"
      :is-home-tab="true"
      @closePoster="closePoster"
      @entoPosterDetail="entoPosterDetail(true)"
    >
    </poster-dialog>
    <search-page v-if="searchPageShow" ref="searchPageRef" @goSearchResult="goSearchResult" @searchResult="searchResult" @hideInput="hideInput"> </search-page>
  </div>
</template>

<script>
import searchPageMixins from '@/mixins/searchPageMixins'
import { mapGetters, mapMutations } from 'vuex'
import { IMG_BASE_URL } from '@/config'
import SouhuoList from '@/components/puppetComponent/SouhuoList'
import SegementLine from '@/components/puppetComponent/SegementLine'
import CategoryTab from './children/CategoryTab'
import QuickTop from '@/components/smartComponent/QuickTop'
import PosterDialog from '@/components/puppetComponent/PosterDialog'
import SearchPage from '@/components/smartComponent/SearchPage'
import Newcomer from './children/Newcomer'
import { firstCategoryLeve, secondCategoryLeve } from '@/api/sort'
import { Indicator, MessageBox } from 'mint-ui'
import { loginSouhuoList, noLoginSouhuoList, BannerList, HomeImage, HomeImageMarkRead, HomeImageOnClick, HomeImageOnClickNoLogin, UploadImgsOnClick, ProductNewPersonShowList } from '@/api/souhuo'
import { OrderWaitHandleNum } from '@/api/my'
import BScroll from 'better-scroll'
import Utils from '@/utils/base'
import { DTK_ENTRANCE_TYPE, TLJ_ORDER_TYPE } from '@/constants/index'

const PATH_OPTION = {
  普通商品: 1,
  免搜商品: 2,
  其他: 3,
  外部: 4,
  淘礼金商品: 5,
  大淘客商品: 6
}

export default {
  name: 'souhuo',
  mixins: [searchPageMixins],
  data() {
    return {
      haveMore: true,
      isFakeSkeleton: true,
      // 获取数据接口，是否为最后一条
      isLastOne: false,
      dataList: [],
      bannerImg: IMG_BASE_URL + '/upaiyun/Sys/20180731/4871370281572548562.png',
      imgUrlsList: [],
      posterBtnImg: IMG_BASE_URL + '/upaiyun/Sys/20180710/5339826543784535297.png',
      isFetch: false, // 是否请求过数据列表
      isReturn: false,
      container: null,
      // 是否可以无限加载
      scrollDisabled: false,
      // 海报
      isShowPoster: false,
      // 价格刷选点击次数
      priceClickNum: 0,
      currentFilterItem: 'comprehensive', // 综合与销量
      SAPPHomeSortType: 0,
      // 是否吸顶
      isFixed: false,
      fixedTop: 0,
      pageScrollTop: 0,
      // 海报图片
      posterID: '',
      homeImageUrl: '',
      WechatPath: '',
      posterPathOption: '', // 链接类型
      // 分类
      categoryLeve1ID: '',
      currentIndex: 0,
      firstClassCategoryList: [],
      secondClassCategoryList: [],
      isShowSecondCategory: false,
      myScroll: null,
      mySubScroll: null,
      platformShopType: null, // 店铺类型筛选 1-天猫，2-拼多多
      // 会员
      posterLevel2Img: IMG_BASE_URL + '/upaiyun/Sys/20220505/4706194022253104136.png',
      posterLevel3Img: IMG_BASE_URL + '/upaiyun/Sys/20220505/5315576268528659615.png',
      isReadLevel: false,
      userLevel: 2, // 用户等级
      isNewcomer: false, // 是否是新人
      isZeroHideScore: false, // 隐藏分是否为0
      newcomerData: [], // 新人专享数据
      isFirstLoadPoster: true, // 是否第一次加载海报
      platformTypeList: [
        {
          platformShopType: null,
          collectively: '全部' // 统称
        },
        {
          platformShopType: 1,
          collectively: '天猫' // 统称
        },
        {
          platformShopType: 2,
          collectively: '拼多多' // 统称
        },
        {
          platformShopType: 3,
          collectively: '京东' // 统称
        },
        {
          platformShopType: 4,
          collectively: '抖音' // 统称
        }
      ]
    }
  },
  components: {
    SouhuoList,
    SegementLine,
    QuickTop,
    PosterDialog,
    SearchPage,
    CategoryTab,
    Newcomer
  },
  mounted() {
    this.fetchHomeImage()
    this.fetchFirstCategoryLeve()
    // 绑定监听事件
    this.$nextTick(() => {
      this.container = document.getElementsByClassName('container')[0]
      this.container.addEventListener('scroll', this.handleScroll)
      document.getElementsByClassName('home-searh')[0].addEventListener('click', this.entoSearchPage, false)
      this.fixedTop = document.getElementById('sch-child').offsetTop
    })
    // app登录之后，刷新页面
    this.$EventBus.$on('app_refreshFlag', () => {
      this.reFetchPage('newcomer')
      this.fetchFirstCategoryLeve()
      this.fetchHomeImage()
    })
  },
  computed: {
    ...mapGetters(['getQrCodeIsShow', 'loginState', 'getIsApp', 'getIsAuthorized', 'getIsHaveUnfinishedOrder']),
    posterLevelImage() {
      if (this.isReadLevel) {
        if (this.userLevel === 3) return this.posterLevel3Img
        else return this.posterLevel2Img
      } else {
        return this.homeImageUrl
      }
    }
  },
  methods: {
    ...mapMutations(['TAB_BAR_MY_BADGE', 'AUTHORIZE_POPUP_SHOW', 'SET_NEW_PERSON_FREE_ORDER_COUNT', 'SET_IS_HAVE_UNFINISHED_ORDER']),
    reFetchPage(from) {
      let routeNames = ['goodsDetail', 'unSearchDetail', 'searchResult', 'sort', 'memberUpgrade', 'newcomer', 'goodsBlacklist']
      if (routeNames.indexOf(from.name) !== -1 && this.container) {
        this.$nextTick(() => {
          this.container.scrollTop = this.pageScrollTop
        })
        if (this.getIsHaveUnfinishedOrder) {
          this.showUnfinishedOrderMsgBox()
        }
      } else {
        this.isNewcomer = Utils.getNewcomerStorage()
        this.isZeroHideScore = Utils.getIsZeroHideScoreStorage()
        this.pageScrollTop = 0
        this.isReturn = false
        this.isLastOne = false
        this.isReturn = false
        this.isFixed = false
        this.priceClickNum = 0
        this.currentFilterItem = 'comprehensive'
        this.SthisHomeSortType = 0
        this.platformShopType = null
        // 新人专享数据获取
        if (this.isNewcomer && !this.isZeroHideScore) this.fetchNewcomerData()
        this.fetchSouhuoList(false, () => {
          // 由微信通知模板进入时，会默认优先渲染souhuo页面，在跳转到自定页面，此时route name已不是[souhuo]
          if (this.$route.name !== 'souhuo') return
          this.fetchBanner()
          if (this.loginState) {
            this.fetTabBarBadge()
            this.$store.dispatch('waitGetFreeCarNum_Action')
          }
        })
      }
      this.$nextTick(() => {
        if (this.myScroll) {
          this.myScroll.refresh()
        }
      })
      if (this.getIsHaveUnfinishedOrder) {
        this.showUnfinishedOrderMsgBox()
      }
    },
    fetchSouhuoList(isDropDown = false, cb) {
      let params = {
        DropDown: isDropDown,
        SAPPHomeSortType: this.SAPPHomeSortType,
        IsHomePage: true,
        CategoryLeve1ID: this.categoryLeve1ID,
        ShopType: this.platformShopType
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.scrollDisabled = true
      if (this.loginState) {
        loginSouhuoList(params)
          .then((res) => {
            this.handleSouhuoSucces(isDropDown, res, cb)
          })
          .catch((res) => {
            this.isFetch = true
            this.haveMore = false
            Indicator.close()
            if (res.ErrMsg) this.$toast(res.ErrMsg)
          })
      } else {
        noLoginSouhuoList(params)
          .then((res) => {
            this.handleSouhuoSucces(isDropDown, res, cb)
          })
          .catch((res) => {
            this.isFetch = true
            this.haveMore = false
            Indicator.close()
            if (res.ErrMsg) this.$toast(res.ErrMsg)
          })
      }
    },
    handleSouhuoSucces(isDropDown, res, cb) {
      Indicator.close()
      if (isDropDown) {
        this.dataList = [...this.dataList, ...res.DataList]
      } else {
        this.dataList = res.DataList
      }
      this.isLastOne = res.BoolSID
      this.isFakeSkeleton = false
      this.isFetch = true
      if (res.BoolSID) {
        this.haveMore = false
      } else {
        this.haveMore = true
      }
      this.scrollDisabled = false
      if (cb) cb()
    },
    fetchHomeImage() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      HomeImage()
        .then((res) => {
          if (res.Data.imgInfo) {
            if (res.Data.imgInfo.PathOption === PATH_OPTION['淘礼金商品']) {
              res.Data.imgInfo.WechatPath = res.Data.imgInfo.WechatPath + `,tljOrderType,${TLJ_ORDER_TYPE['弹窗订单']}`
            }
            if (res.Data.imgInfo.PathOption === PATH_OPTION['大淘客商品']) {
              res.Data.imgInfo.WechatPath = res.Data.imgInfo.WechatPath + `,dtkEntranceType,${DTK_ENTRANCE_TYPE['弹窗']}`
            }
            this.homeImageUrl = res.Data.imgInfo.ImgUrl
            this.WechatPath = res.Data.imgInfo.WechatPath
            this.posterID = res.Data.imgInfo.ID
            this.userLevel = res.Data.userLevel
            this.posterPathOption = res.Data.imgInfo.PathOption
            if (res.Data.isReadLevel) {
              this.isReadLevel = true
            } else {
              this.isShowPoster = !res.Data.isRead
            }
            if (!this.isReadLevel && !this.isShowPoster && this.getIsHaveUnfinishedOrder) {
              this.showUnfinishedOrderMsgBox()
            }
          }
          Indicator.close()
        })
        .catch((res) => {
          if (res.ErrMsg) this.$toast(res.ErrMsg)
          Indicator.close()
        })
    },
    // banner
    fetchBanner() {
      BannerList()
        .then((res) => {
          this.imgUrlsList = res.BannerInfoList
        })
        .catch((res) => {
          if (res.ErrMsg) this.$toast(res.ErrMsg)
        })
    },
    // tabBar数字提示
    fetTabBarBadge() {
      // 待完成、待收货、评价邀请数字相加和（用于第一次进入页面时显示我的页面上的badge）
      OrderWaitHandleNum()
        .then((res) => {
          this.TAB_BAR_MY_BADGE(Number(res.Msg) || 0)
        })
        .catch((res) => {
          if (res.ErrMsg) this.$toast(res.ErrMsg)
        })
    },
    fetchFirstCategoryLeve() {
      this.firstClassCategoryList = [{ Key: '', Value: '今日热门' }]
      firstCategoryLeve()
        .then((res) => {
          this.firstClassCategoryList = [...this.firstClassCategoryList, ...res]
          this.$nextTick(() => {
            this.myScroll = new BScroll(this.$refs.wrapper, {
              scrollX: true,
              scrollY: false,
              click: true
            })
          })
        })
        .catch((res) => {
          if (res.ErrMsg) this.$toast(res.ErrMsg)
        })
    },
    fetchSecondCategoryLeve(key) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      secondCategoryLeve({ level1ID: key })
        .then((res) => {
          Indicator.close()
          this.secondClassCategoryList = res
          this.$nextTick(() => {
            this.mySubScroll = new BScroll(this.$refs.subWrapper, {
              scrollX: true,
              scrollY: false,
              click: true
            })
          })
        })
        .catch((res) => {
          if (res.ErrMsg) this.$toast(res.ErrMsg)
          Indicator.close()
        })
    },
    // 新人专享数据
    fetchNewcomerData() {
      ProductNewPersonShowList()
        .then((res) => {
          this.newcomerData = res.Data
          this.SET_NEW_PERSON_FREE_ORDER_COUNT(res.NewMemberOrderNumber)
          this.fixedTop = document.getElementById('order_type').offsetTop
        })
        .catch((err) => {
          if (err.ErrMsg) this.$toast(err.ErrMsg)
        })
    },
    loadMore() {
      if (!this.isFetch) return
      if (this.isLastOne) {
        this.haveMore = false
        return
      }
      this.haveMore = true
      this.fetchSouhuoList(true)
    },
    // 轮播图片点击
    swiperPage(path, id, PathOption) {
      // 淘礼金类型
      if (PathOption === PATH_OPTION['淘礼金商品']) {
        path = path + `,tljOrderType,${TLJ_ORDER_TYPE['banner订单']}`
      }
      // 大淘客类型
      if (PathOption === PATH_OPTION['大淘客商品']) {
        path = path + `,dtkEntranceType,${DTK_ENTRANCE_TYPE['banner']}`
      }
      // 新需求处理位置
      if (this.loginState) {
        if (path) {
          this.handlePath(path, PathOption)
          // 记录用户点击轮播图
          UploadImgsOnClick({ uploadImgsID: id })
        }
      } else {
        if (!this.getIsAuthorized && this.getIsApp) {
          // 弹出授权登录弹窗
          this.AUTHORIZE_POPUP_SHOW(true)
          return
        }
        if (this.getIsAuthorized && this.getIsApp) {
          this.$store.commit('LOGINDIALOG_SHOW', true)
          return
        }
        this.$store.commit('LOGINDIALOG_SHOW', true)
      }
    },
    // 返利说明
    entoRebatenote() {
      this.$router.push('rebateNote')
    },
    // 进入分类页
    entoSortPage() {
      this.$router.push({
        name: 'sort'
      })
    },
    entoSearchResult(val) {
      this.$router.push({ name: 'searchResult', query: { search: val } })
    },
    // 进入详情页
    entoDetailPage(productID, isFreeCard) {
      this.$router.push({
        name: 'goodsDetail',
        query: {
          productID: productID,
          isFreeCard: isFreeCard
        }
      })
    },
    // 返回顶部
    returnTop() {
      this.container.scrollTop = 0
    },
    // 滚动监听
    handleScroll(e) {
      // 滚动高度
      let scrollTop = this.container.scrollTop
      this.pageScrollTop = scrollTop
      // 屏幕高度
      let documentH = document.documentElement.clientHeight || document.body.clientHeight
      if (scrollTop > documentH) {
        this.isReturn = true
      } else {
        this.isReturn = false
      }
      this.isFixed = scrollTop > this.fixedTop
    },
    // 关闭海报
    closePoster() {
      if (!this.isReadLevel && this.loginState) {
        // TODO: 已读
        this.handlePosterRead(() => {})
      }
      this.isFirstLoadPoster = false
      this.isShowPoster = false
      this.isReadLevel = false
      // 关闭海报，如存在未完成订单，则显示弹窗
      if (this.getIsHaveUnfinishedOrder) {
        this.showUnfinishedOrderMsgBox()
      }
    },
    entoPosterDetail(flag) {
      this.isShowPoster = false
      if (!flag) {
        this.$router.push({ name: 'posterDetail' })
      } else {
        // 是否是V2、V3会员
        if (this.isReadLevel) {
          this.isReadLevel = false
          // 会员说明页面
          this.$router.push({ name: 'memberUpgrade' })
        } else {
          // 海报已读
          if (this.loginState) {
            this.handlePosterRead(() => {
              this.handlePath(this.WechatPath, this.posterPathOption)
            })
          } else {
            this.handlePath(this.WechatPath, this.posterPathOption)
          }
        }
        // 记录用户点击
        if (this.loginState) HomeImageOnClick({ homeImageID: this.posterID })
        else HomeImageOnClickNoLogin({ homeImageID: this.posterID })
      }
    },
    // 已读
    handlePosterRead(fn) {
      HomeImageMarkRead({ homeImageID: this.posterID }).then((res) => {
        fn()
      })
    },
    // 展示【存在未完成订单】弹窗
    showUnfinishedOrderMsgBox() {
      this.SET_IS_HAVE_UNFINISHED_ORDER(false)
      MessageBox({
        title: '提示',
        message: '亲，存在一笔订单未完成，是否前往继续完成？',
        showCancelButton: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        cancelButtonText: '先不去',
        confirmButtonText: '继续完成',
        confirmButtonClass: 't_f23030'
      }).then((action) => {
        if (action === 'confirm') {
          this.$router.push({
            name: 'order',
            query: {
              tabIndex: 1
            }
          })
        }
      })
    },
    // 综合与销量筛选
    filterChange(currentItem) {
      if (this.isFixed) this.container.scrollTop = this.fixedTop
      if (this.currentFilterItem !== currentItem) {
        this.priceClickNum = 0
        this.currentFilterItem = currentItem
        this.SAPPHomeSortType = null
        this.hasMore = true
        if (currentItem === 'sale') {
          this.SAPPHomeSortType = 1
        } else if (currentItem === 'comprehensive') {
          this.SAPPHomeSortType = 0
        }
        this.fetchSouhuoList()
      }
    },
    // 价格刷选
    priceFilter() {
      if (this.isFixed) this.container.scrollTop = this.fixedTop
      this.currentFilterItem = ''
      this.priceClickNum = this.priceClickNum + 1
      this.haveMore = true
      if (this.priceClickNum % 2 !== 0) {
        // 价格从低到高
        this.SAPPHomeSortType = 3
        this.fetchSouhuoList()
      } else {
        // 价格从高到底
        this.SAPPHomeSortType = 2
        this.fetchSouhuoList()
      }
    },
    // 天猫与拼多多筛选（不和销量、价格冲突，可以同时筛选）
    platformChange(platformShopType = null) {
      if (this.isFixed) this.container.scrollTop = this.fixedTop
      this.haveMore = true
      if (this.platformShopType !== platformShopType) {
        this.platformShopType = platformShopType
        this.fetchSouhuoList()
      }
    },
    // 一级类目切换
    switchListTab(index, key) {
      if (this.isFixed) this.container.scrollTop = this.fixedTop
      if (this.currentIndex === index) {
        this.isShowSecondCategory = !this.isShowSecondCategory
      } else {
        this.currentIndex = index
        this.$nextTick(() => {
          let sortItem = document.getElementsByClassName('sort_list')[0].children[index]
          let sortLine = document.getElementsByClassName('sort_line')[0]
          let clientWidth = sortItem.clientWidth
          let offsetLeft = sortItem.offsetLeft
          let moveNum = offsetLeft + clientWidth / 2
          sortLine.style.left = moveNum + 'px'
          sortLine.style.transform = 'translateX(-11px)'
        })
        // 今日热门与其它类目
        if (key) {
          this.fetchSecondCategoryLeve(key)
          this.isShowSecondCategory = true
          this.categoryLeve1ID = key
        } else {
          this.isShowSecondCategory = false
          this.categoryLeve1ID = ''
        }
        this.currentFilterItem = 'comprehensive'
        this.priceClickNum = 0
        this.SAPPHomeSortType = 0
        this.platformShopType = null
        this.fetchSouhuoList()
      }
    },
    handlePath(path, pathOption) {
      if (pathOption === PATH_OPTION['外部']) {
        this.handOutLinkPath(path)
      } else {
        this.handleRoutePath(path)
      }
    },
    // 处理外部链接跳转
    handOutLinkPath(path) {
      if (this.getIsApp) {
        this.$uni.postMessage({
          data: {
            outsideLink: true,
            tempLink: path
          }
        })
      } else {
        window.open(path, '_self')
      }
    },
    // 处理内部路由跳转
    handleRoutePath(path) {
      let routerArray = path.split(',')
      let queryObj = {}
      if (routerArray.length > 1) {
        for (let i = 1; i < routerArray.length; i = i + 2) {
          queryObj[routerArray[i]] = routerArray[i + 1]
        }
      }
      this.$router.push({
        name: routerArray[0],
        query: queryObj
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$toast.clear()
    this.TAB_BAR_SHOW(true)
    next()
  },
  beforeRouteEnter(to, from, next) {
    next((app) => {
      app.searchPageShow = false
      if (app.isFirstLoadPoster) {
        app.fetchHomeImage()
      }
      app.TAB_BAR_SHOW(true)
      app.reFetchPage(from)
    })
  }
}
</script>

<style scoped lang="scss">
.container {
  background: #f1f1f1;
  overflow-y: scroll;
}
.fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
  z-index: 900;
}
.top-search {
  background: #fff;
  padding: 2% 3%;
}
.top-search .search {
  height: 34px;
  line-height: 34px;
  background: #f2f2f2;
  border-radius: 5px;
  color: #9b9b9b;
  text-align: left;
  text-indent: 12%;
}
.top-search .search-icon {
  position: absolute;
  left: 6%;
  background: url('../../assets/icon/search.png') no-repeat;
  background-size: 22px 22px;
  background-position: center;
  height: 34px;
  width: 25px;
}
/* search */
.seacrh {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  font-size: 14px;
  z-index: 1;
  background: #fff;
  color: #666;
  opacity: 0.8;
  width: 90%;
  left: 5%;
  text-align: center;
  padding: 5px 0;
  margin-top: 8px;
  border-radius: 40px;
  box-shadow: 0 2px 3px -1px #ccc;
}
.search_txt {
  margin-left: 10rpx;
}
/* 轮播图 */
.mint-swipe {
  height: 12.8rem;
}
.mint-swipe-item img {
  width: 100%;
  display: block;
}
.suohuo_txt {
  background: #fff;
  display: flex;
  padding: 10px;
  margin-bottom: 10px;
  justify-content: space-between;
  font-size: 12px;
  color: #666;
}
.suohuo_txt > div {
  display: flex;
  justify-content: flex-start;
}
.suohuo_txt .iconfont {
  color: #f23030;
  margin-right: 4px;
  font-size: 14px;
  margin-top: 1px;
  float: left;
}
.flex {
  display: flex;
}
.poster_btn {
  position: fixed;
  bottom: 55px;
  right: 0px;
  width: 75px;
  height: 75px;
}
.poster_btn img {
  width: 100%;
  height: 100%;
}
/* 排序 */
.sch-reult {
  width: 100%;
  position: relative;
  overflow-x: scroll;
}
.s_result {
  display: inline-flex;
  align-items: center;
  background: #fff;
  align-items: flex-start;
  // padding: 0 10px;
  padding-left: 2%;
  box-sizing: border-box;
  height: 45px;
  line-height: 45px;
  // overflow-x: scroll;
}
.filter_tab {
  position: relative;
  font-size: 12px;
  margin-right: 10px;
}
.filter_tab span {
  min-width: 58px;
  padding: 2px 0;
  box-sizing: border-box;
  border-radius: 3px;
  background: #f2f2f7;
  display: inline-block;
  text-align: center;
  line-height: normal;
}
.filter_end {
  flex: 2;
}
.icon-view {
  margin-bottom: 3px;
  display: inline-block;
  vertical-align: bottom;
}
@supports (-webkit-overflow-scrolling: touch) {
  .icon-view {
    vertical-align: middle;
    margin-bottom: 2px;
  }
}
.triangle {
  width: 0;
  height: 0;
  border-left: 4px solid transparent !important;
  border-right: 4px solid transparent !important;
}
.triangle-up {
  border-bottom: 4px solid;
  border-bottom-color: #999;
}
.triangle-down {
  margin-top: 2px;
  border-top: 4px solid;
  border-top-color: #999;
}
.icon-up {
  border-bottom-color: #000;
}
.icon-down {
  border-top-color: #000;
}
.filter_active span {
  background-color: rgba(244, 53, 48, 0.1);
  color: #f43530;
}
/* 置顶 */
#order_type {
  background: #fff;
}
.isFixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}
/* 分类 */
.sort_wrap,
.subsort_wrap {
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  border-bottom: 1px solid #eee;
  overflow: hidden;
  padding: 0;
  margin: 0 10px;
  width: calc(100% - 20px);
}
.sort_wrap .sort_list {
  height: 42px;
  line-height: 42px;
  display: flex;
  padding-right: 20px;
  position: relative;
}
.sort_wrap .sort_icon {
  height: 34px;
  background: #fff;
  position: absolute;
  right: 0;
  padding: 12px 10px 0;
  box-sizing: border-box;
}
.sort_wrap .sort_icon > i {
  color: #666;
}
.sort_wrap .sort_list li {
  flex-shrink: 0;
  width: 64px;
  text-align: center;
  margin-right: 16px;
  font-size: 14px;
  color: #999;
}
.sort_wrap .sort_list li.lengthClass {
  width: 34px;
}
.sort_wrap .sort_list li.active {
  font-size: 15px;
  font-weight: bold;
  position: relative;
  color: #000;
}
.sort_wrap .sort_line {
  position: absolute;
  bottom: 0;
  left: 0;
  display: block;
  width: 22px;
  height: 0;
  transform: translateX(19px);
  transition: all 0.3s;
  border-bottom: 3px solid #f23030;
}
/* 二级类目 */
.categoryShowAnim {
  animation: categoryAnim 0.25s ease;
}
.subsort_wrap .subsort_list {
  display: flex;
  padding: 12px 0;
}
.subsort_list li {
  flex-shrink: 0;
  width: 60px;
  padding: 0 4px;
  text-align: center;
}
.subsort_list .sort_img {
  width: 60%;
  margin: 0 auto;
  padding-bottom: 70%;
  height: 0;
}
.subsort_list .sort_txt {
  font-size: 13px;
  color: #999;
}
.sort_img img {
  width: 100%;
}
@media screen and (height: 812px) {
  .filter_tab span {
    width: 8vh;
  }
}

@keyframes categoryAnim {
  from {
    height: 0;
  }
  to {
    height: 80px;
  }
}
</style>
